import React from 'react';
import {Link} from 'react-router-dom';
import Grid from '@material-ui/core/Grid'


const List = ({list, setList}) => {
    return (
        <div>
        <Link to='/'>Back home</Link>


         {list.map((listItem)=>(

  <Grid container>
 
             <div key={listItem.id}>
             <Grid item>
             {listItem.title}
             </Grid>
             <Grid item>
             <img src={listItem.image} alt=''/>
             </Grid>
             </div>
 </Grid>
         ))}
        </div>
    )
}

export default List
